/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
import { getQuery, isVBAWorkflow, isIframe } from '@util'
import { SaasAxios } from '@quick/saas-axios'
import clientApi from '@plus/client-connect'

const clientName = clientApi.getCurrentClient()


export const isWPSClient = function () {
  if (typeof cefQuery != 'undefined' || typeof wpsQuery != 'undefined') {
    return true
  } else {
    return false
  }
}



export const listenerLogin = (logincb) => {
  clientApi.addListener({ clientName, data:{
    listenerNames: ['event.account.login'], 
    cb: logincb, // 回调
    listenerMode: 'COMMON'
  }})
}

export const listenerLogout = (logoutcb) => {
  clientApi.addListener({ clientName, data:{
    listenerNames: ['event.account.logout'], 
    cb: logoutcb, // 回调
    listenerMode: 'COMMON'
  }})
}

export const registerLogin = function (logincb, logoutcb) {
  // VBA情况下不注册监听用户的登录和注销
  if (isVBAWorkflow()) return

  listenerLogin(logincb)
  listenerLogout(logoutcb)
}

export const removeRegisterLogin = function () {
  // VBA情况下不清除监听用户的登录和注销
  if (isVBAWorkflow()) return

  clientApi.removeListener({ clientName, data:{
    listenerNames: ['event.account.login', 'event.account.logout', 'event.account.switchaccountfinished']
  }})
  
}

export const callLogin = function (cb) {
  clientApi.login({ clientName, cb})
}

/**
 * 关闭弹窗
 */
export const closeDialog = cb => {
  clientApi.callCommonApi({ clientName, eventName: 'common.webview.close', data: {
    params: {}, cb
  }})
}

/**
 * win 关闭tab
 */
export const closeWindow = () => {
  clientApi.callCommonApi({
    clientName, eventName: 'closeWindow', data: {}
  })
}
/**
 * 通知客户端创建成功
 * @param {*} companyId
 * @param {*} companyName
 * @param {*} cb
 */
export const createCompanySuccess = (companyId, companyName, cb) => {
  clientApi.callCommonApi({ 
    clientName, 
    eventName: 'onCreateCompanySuccess', 
    data: {
      params: {
        companyId,
        companyName,
      },
      cb
    }
  })
}

/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
export const checkApiSupport = (apiName, cb) => {
  clientApi.callCommonApi({ 
    clientName, 
    eventName: 'common.util.support', 
    data: [apiName, cb]
  })
}

/**
 *  跳转到企业首页
 * @param {*} apiName
 * @param {*} cb
 */
export const sendCommand = (cmd, cb = '') => {
  clientApi.callCommonApi({ 
    clientName, 
    eventName: 'sendCommand', 
    data: {
      params: {
        cmd,
      },
      cb
    }
  })
}
/**
 * 刷新企业列表
 * @param {*} cb
 */
export const refreshCompanyList = cb => {
  checkApiSupport('refreshCompanyList', data => {
    if (data) {
      clientApi.callCommonApi({ 
        clientName, 
        eventName: 'refreshCompanyList', 
        data: {
          params: {},
          cb
        }
      })
    } else {
      // 兼容新标签页更新企业列表
      clientApi.callCommonApi({ 
        clientName, 
        eventName: 'common.util.openUrl', 
        data: {
            params: {
              url: 'ksoqing:////type=refreshcompanylist',
            },
          cb
        }
      })
    }
  })
}

/**
 * vba应用刷新企业列表
 * @param {*} cb
 */
 export const refreshVbaCompanyList = cb => {
    clientApi.callCommonApi({ 
      clientName, 
      eventName: 'vbapaycomponent.refreshCompanyList', 
      data: {
        params: {},
        cb
      }
    })
}

// 获取app信息
export const getAppInfo = cb => {
  return clientApi.getAppVersion({ clientName })
}

export const listenerSdkLogin = (logincb) => {
  // 备注：event.accountsdk.login 只有23年3月份包才有的API，故此需要兼容
  let isExecuted = false
  const fn = (...params) => {
    if (isExecuted) return
    isExecuted = true
    logincb(...params)
  }
  listenerLogin(fn)
  clientApi.addListener({ clientName, data:{
    listenerNames: ['event.accountsdk.login'], 
    cb: fn, // 回调
    listenerMode: 'COMMON'
  }})
}

export const listenerSdkLogout = (logoutcb) => {
  // 备注：event.accountsdk.logout 只有23年3月份包才有的API，故此需要兼容
  let isExecuted = false
  const fn = (...params) => {
    if (isExecuted) return
    isExecuted = true
    logoutcb(...params)
  }
  listenerLogout(fn)
  clientApi.addListener({ clientName, data:{
    listenerNames: ['event.accountsdk.logout'], 
    cb: fn, // 回调
    listenerMode: 'COMMON'
  }})
}

/**
 * @desc 获取是否教育版,备注，有202507统一版和旧版区分
 * @doc https://365.kdocs.cn/l/cclrpzhChfMj?from=koa&R=L1MvMg==
 * */
export const getIsTeach = async () => {
  const cb = data => {
    if (data) {
      try {
        const { status } = JSON.parse(data)
        return status
      } catch (e) {
        return false
      }
    }
  }

  return new Promise(resolve => {
    getOemSupported({ key: 'OemJsonFormat' }, data => {
      const status = cb(data)
      const key = status ? 'FrontPageForWPS365Edu' : 'EducationVersion'
      getOemSupported({ key }, res => {
        const result = cb(res)
        resolve(result)
      })
    })
    setTimeout(() => {
      resolve(false)
    }, 3000)
  })
}

/**
 * 检查是否支持客户端接口某项功能功能
 * @param feature 参数举例：{"feature":"jumpToCloudLocation"}，feature为需要检查的功能名称
 * 返回：{"support":"true", "callstatus":"ok"} support:true支持，false不支持，接口调不通也是不支持
 */
export const checkCloudFeatureSupport = (feature, cb) => {
  clientApi.callCommonApi({ 
    clientName, 
    eventName: 'common.wpscloud.checkCloudFeatureSupport',
    data: {
      params: {feature},
      cb
    }
  })
}

//vba url
export const openTagByVbaPay = (params) => {
  clientApi.callCommonApi({ 
    clientName, 
    eventName: 'common.payment.openTagByVbaPay',
    data: {
      params
    }
  })
}

// 获取oem容器是否支持
export const getOemSupported = (params, cb) => {
  clientApi.callCommonApi({
    clientName, 
    eventName: 'getOemSupported', 
    data: {
      params,
      cb
    }
  })
}

//vba send common
export const vbaSendCommand = (cmd, cb) => {
  clientApi.callCommonApi({
    clientName, 
    eventName: 'vbapaycomponent.sendCommand', 
    data: {
      params: {
        cmd,
      },
      cb
    }
  })
}

// 关闭当前tab
export const closeWebView = (params, cb) => {
  clientApi.callCommonApi({
    clientName, 
    eventName: 'close', 
    data: {
      params,
      cb
    }
  })
}

// 通知加载完成
export const onComponentLoaded = () => {
  clientApi.callCommonApi({
    clientName, 
    eventName: 'onComponentLoaded',
  })
}

// 添加容器
export const addDragArea = (params, cb) => {
  clientApi.callCommonApi({
    clientName, 
    eventName: 'common.webview.addDragArea',
    data: {
      params,
      cb
    }
  })
}

// 通知创建企业更新
export const updateRegistry = () => {
  clientApi.callCommonApi({
    clientName, 
    eventName: 'vbapaycomponent.updateRegistry'
  })
}



//  校验当前容器右侧面板容器入口是否可见
// 【金山文档 | WPS云文档】 原子化引导客户端接口文档 https://365.kdocs.cn/l/ckit0zEnudLb
export const isDockPanelEntryVisible = (isLingXi = false, params, cb) => {
  const supportCreateCompanyPageApi = window['supportCreateCompanyPageApi']
  const onOperateVisible = (res) => {
    const { callstatus, result } = JSON.parse(res)
    if (callstatus === 'ok' && result === true) { // 右侧面板入口存在
      cb(true)
    } else {
      cb(false)
    }
  }
  if (supportCreateCompanyPageApi) {
    clientApi.callCommonApi({
      clientName,
      eventName: 'common.dockPanel.isDockPanelEntryVisible',
      data: {
        params,
        cb: onOperateVisible
      }
    })
  }
  else if (isLingXi && !supportCreateCompanyPageApi) {
    // 目前只有灵犀支持通用浏览器容器的判断
    clientApi.callCommonApi({
      clientName,
      eventName: 'lingxi.isDockPanelEntryVisible',
      data: {
        params: {},
        cb: onOperateVisible
      }
    })
    return
  } else {
    cb && cb(false)
  }
}

// 设置侧边栏可见性
export const setDockPanelVisible = (params, cb) => {
  // 新应用容器
  const supportCreateCompanyPageApi = window['supportCreateCompanyPageApi']
  supportCreateCompanyPageApi && clientApi.callCommonApi({
    clientName,
    eventName: 'common.dockPanel.setDockPanelVisible',
    data: {
      params,
      cb
    }
  })
  // 通用浏览器容器
  !supportCreateCompanyPageApi && clientApi.callCommonApi({
    clientName,
    eventName: 'docs.dockmsg.setDockPanelVisible',
    data: {
      params,
      cb
    }
  })
}
// 校验新应用容器右侧面板的展示状态
export const checkDockPanelVisibleInNewContainer = (params, cb) => {
  // 新应用容器
  clientApi.callCommonApi({
    clientName,
    eventName: 'common.dockPanel.isDockPanelVisible',
    data: {
      params,
      cb
    }
  })
}
// 校验通用浏览器容器右侧面板的展示状态
export const checkDockPanelVisibleInCommonContainer = (params, cb) => {
  // 新应用容器
  clientApi.callCommonApi({
    clientName,
    eventName: 'docs.dockmsg.isDockPanelVisible',
    data: {
      params,
      cb
    }
  })
}

export const openWoaFlow = () => {
  if (!isWPSClient()) {
    window.open(`${SaasAxios.getHost('woa')}/im/message`)
    return
  }
  const onOperateIM = (res) => {
    const { callstatus, result } = JSON.parse(res)
    if (callstatus === 'ok' && result === false) { // 右侧面板未打开，点击打开
      // wps客户端响应优先级受端内逻辑控制：右侧面板 > 内嵌协作 > 协作客户端 > 引导下载页
      window.open('ksoxz://xz.wps.cn/open')
    } else if (callstatus === 'ok' && result === true) {  // 右侧面板已打开，点击关闭
      setDockPanelVisible({ panelId: 'dockpanel_webim', visible: false }, () => {
      })
    } else {
      window.open('ksoxz://xz.wps.cn/open')
    }
  }
  // 新应用容器
  window['supportCreateCompanyPageApi'] && checkDockPanelVisibleInNewContainer({ panelId: 'dockpanel_webim' }, (res) => {
    onOperateIM(res)
  })
  // 通用浏览器容器
  !window['supportCreateCompanyPageApi'] && checkDockPanelVisibleInCommonContainer({ panelId: 'dockpanel_webim' }, (res) => {
    onOperateIM(res)
  })
}

export const openLingxiFlow = () => {
  const onOperateLingxi = (res) => {
    const { callstatus, result } = JSON.parse(res)
    if (callstatus === 'ok' && result === false) { // 右侧面板未打开，点击打开
      setDockPanelVisible({ panelId: 'dockpanel_lingxi', visible: true })
    } else if (callstatus === 'ok' && result === true) {  // 右侧面板已打开，点击关闭
      setDockPanelVisible({ panelId: 'dockpanel_lingxi', visible: false })
    } else if (callstatus === 'error') {
      window.open(`${SaasAxios.getHost('lingxi')}`)
    }
  }
  // 校验是否存在灵犀右侧面板的入口, 不存在直接新开tab 打开
  isDockPanelEntryVisible(true, { panelId: 'dockpanel_lingxi' }, (support) => {
    if (!support) {
      window.open(`${SaasAxios.getHost('lingxi')}`)
      return
    }
    // 校验灵犀右侧面板是否打开，新应用容器
    window['supportCreateCompanyPageApi'] && checkDockPanelVisibleInNewContainer({ panelId: 'dockpanel_lingxi' }, (res) => {
      onOperateLingxi(res)
    })
    // 校验灵犀右侧面板是否打开，通用浏览器
    !window['supportCreateCompanyPageApi'] && checkDockPanelVisibleInCommonContainer({ panelId: 'dockpanel_lingxi' }, (res) => {
      onOperateLingxi(res)
    })
  })
}